import { useDispatch } from 'react-redux';
import { CheckboxItem } from 'components/core/checkbox-group';

import { useAppSelector } from 'redux/store';
import { setModalOpen, setModalTitle, setModalType } from 'redux/stores/woo-requests';
import { IFilters } from 'components/filter-sidebar/filter-sidebar';
import { useCategory } from '../queries/use-category';

export const useWooRequestsFilters = (onChange: (categoryIds: string[]) => void): IFilters => {
	const dispatch = useDispatch();
	const maxItemsAmount = 8;

	const { categories, categoriesCount, wooRequestsCountPerCategory } = useAppSelector((state) => state.wooRequests);
	const { selectedCategories, setSelectedCategoriesParam } = useCategory();

	const activeCategories = new Set(
		wooRequestsCountPerCategory.filter((category) => (category.count || 0) > 0).map((category) => category.sitemap)
	);

	const options = categories
		.filter((category) => activeCategories.has(category.apiLabel))
		.map((item) => ({ ...item, key: 'selectedCategories' }));

	const categoryOptions = categories &&
		categories.length > 0 && {
			maxItemsAmount,
			id: 'categories',
			type: 'checkbox',
			title: 'Categorie',
			onChange: (items: CheckboxItem[], active: boolean): void => {
				if (active) {
					const mergedCategories = [...selectedCategories, ...items];
					setSelectedCategoriesParam(mergedCategories.length > 0 ? mergedCategories : null);
					onChange(mergedCategories.map((item) => String(item.id)));
				} else {
					const itemIds = new Set(items.map((newItem) => newItem.id));
					const newCategories = selectedCategories.filter((selectedItem) => !itemIds.has(selectedItem.id));
					setSelectedCategoriesParam(newCategories.length > 0 ? newCategories : null);
					onChange(newCategories.map((item) => String(item.id)));
				}
			},
			value: selectedCategories,
			options: [...options],
			showMore: 'Toon meer categorieën',
			handleShowMore:
				categoriesCount > maxItemsAmount
					? () => {
							dispatch(setModalTitle('Categorie'));
							dispatch(setModalType('categories'));
							dispatch(setModalOpen(true));
					  }
					: undefined
		};

	return [categoryOptions].filter(Boolean) as IFilters;
};
